/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireVersionModel} from "../../models/questionnaire-version-model";


export interface QuestionnaireVersionsGetParams {
    questionnaireGuid?: string;
}

export function questionnaireVersionsGet(http: HttpClient, rootUrl: string, params: QuestionnaireVersionsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireVersionModel[]>> {
    const rb = new RequestBuilder(rootUrl, questionnaireVersionsGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params) {
        rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireVersionModel[]>;
        })
    );
}

questionnaireVersionsGet.PATH = '/api/v1/questionnaires/{questionnaireGuid}/versions';
